import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const Stamp = {
  namespaced: true,
  state: {
    ranks: [],
    stamp_total: 0,
    rankings: [],
    histories: [],
    user_type: 0,
    user_create_at: null
  },
  getters: {
    ranks: state => state.ranks,
    rankings: state => state.rankings,
    stamp_total: state => state.stamp_total,
    histories: state => state.histories,
    user_type: state => state.user_type,
    user_create_at: state => state.user_create_at
  },
  mutations: {
    UPDATE_RANKS(state, payload) {
      state.ranks = payload
    },
    UPDATE_RANKINGS(state, payload) {
      state.rankings = payload
    },
    UPDATE_STAMP_TOTAL(state, payload) {
      state.stamp_total = payload
    },
    UPDATE_STAMP_HISTORY(state, payload) {
      state.ranks = payload['ranks']
      state.rankings = payload['rankings']
      state.stamp_total = payload['stamp_total']
      state.histories = payload['histories']
      state.user_type = payload['user_type']
      state.user_create_at = payload['user_create_at']
    }
  },
  actions: {
    /**
     * スタンプ獲得履歴の取得
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchStampHistory({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getStampHistory(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_STAMP_HISTORY', res.data.data)
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
